import { useMemo } from 'react';

import { useFeature } from 'src/app/FeatureToggle';
import useCredentialsExpiringSoonCount from 'src/common/credentials/useCredentialsExpringSoonCount';
import { NavItem } from 'src/common/NavBar/TopLevelNavItemContext';
export function useNonRideOrderingPortalTabs(initialTabs: NavItem[]) {
  const {
    isEnabled: isMemberCredentialsEnabled,
    isLoading: isMemberCredentialsLoading,
  } = useFeature('member credentials');

  const expiredMemberCredentialsCount = useCredentialsExpiringSoonCount();

  const tabs = useMemo(() => {
    const credentialsTabExists = initialTabs.some(
      (tab) => tab.name === 'Credentials'
    );

    if (
      !isMemberCredentialsLoading &&
      isMemberCredentialsEnabled &&
      !credentialsTabExists
    ) {
      return [
        ...initialTabs,
        {
          name: 'Credentials',
          href: '/team/member-credentials',
          badgeCount: expiredMemberCredentialsCount?.team,
        },
      ];
    }

    return initialTabs;
  }, [
    initialTabs,
    isMemberCredentialsEnabled,
    isMemberCredentialsLoading,
    expiredMemberCredentialsCount,
  ]);

  return tabs;
}
